(function (module) {
    "use strict";

    module.service('smoothDataService', ['synchronousEventsBus', '$q', function(this: $TSFixMe, synchronousEventsBus: $TSFixMe, $q: ng.IQService) {
        var service = this;

        service.registerEvents = function () {
            synchronousEventsBus.$on('dataAfterSkippedChanged', function (e: $TSFixMe, args: $TSFixMe) {
                return service.smoothData(args.forecast, args.parameters, args.forecast.period);
            });
        }

        service.smoothData = function (forecast: $TSFixMe, parameters: $TSFixMe, period: $TSFixMe) {


            if (angular.isUndefinedOrNull(forecast.dataAfterSkipped)) {
                return $q.when();
            }


            if (angular.isUndefinedOrNull(forecast.dataAfterSmoothing)
                || forecast.dataAfterSmoothing.length != forecast.dataAfterSkipped.length) {
                forecast.dataAfterSmoothing = [];
            }

            var smoothingData = [];

            for (var i = 0; i < Math.floor(period / 2); ++i) {
                forecast.dataAfterSmoothing[i] = undefined;
            }

            for (var i = Math.floor(period / 2); i < forecast.dataAfterSkipped.length; i++) {
                var sum = parseInt(forecast.dataAfterSkipped[i]);
                for (var j = Math.floor(period / 2); j > 0; --j) {
                    sum += parseFloat(forecast.dataAfterSkipped[i - j]);
                    sum += parseFloat(forecast.dataAfterSkipped[i + j]);
                }
                sum /= period;

                forecast.dataAfterSmoothing[i] = sum;
            }

            return synchronousEventsBus.$broadcast('dataAfterSmoothingChanged', { forecast: forecast, parameters: parameters });
        }
    }]);
    module.run(['smoothDataService', function (service: $TSFixMe) {
        service.registerEvents();
    }]);

})(angular.module('topline.services'));